function showProgressAnimation(inline){
	if(typeof inline === undefined){
		inline = false;
	}
	var $blanket = $('<div role="progressbar"><span id="spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></span></div>');

	if(inline){
		return $('<div>').append($blanket.addClass('blanket inline')).html();
	}else{
		$blanket.attr('id', 'blanket').appendTo('body').hide().fadeIn('fast');
	}
}

(function($){

	updateResponsiveLayout();
	$(window).on('resize', updateResponsiveLayout);

	/*
	 *  GENERAL: SMOOTH SCROLLING
	 */

	var pageOffset = 0;
	if($('#page-toolbar').length){
		$('#page-toolbar').fixedsticky();
		toolbarHeight = $('#page-toolbar').outerHeight();
		pageOffset = -1 * toolbarHeight;
	}

	// At page load, smooth scroll to anchor target from page URL, if any
	$(window).on('load', function(){
		var wheretogo = location.hash;
		// No exact match for ID
		if(wheretogo !== '' && !$(wheretogo).length){
			wheretogo = $('[id^=' + wheretogo.replace(/^#\/?/, '') + ']:first');
		}
		if(wheretogo !== '' && $(wheretogo).length){
			$.smoothScroll({
				scrollTarget: wheretogo,
				offset: pageOffset,
				speed: 400
			});
			if($(wheretogo).hasClass('toggler')){
				$(wheretogo).trigger('click');
			}
		}
	});

	// Use smooth scrolling for links to elements on same page except lightboxes
	$('body a[href^="#"]:not([data-featherlight])').on('click', function(e){
		e.preventDefault();
		if(!$(this).hasClass('disabled')){
			var wheretogo = $(e.target).attr('href').replace(/^#\/?/, '');
			if(document.getElementById(wheretogo)){
				$.smoothScroll({
					scrollTarget: '#' + wheretogo,
					offset: pageOffset,
					speed: 400
				});
			}
		}
	});


	/*
	 *  GENERAL: AJAX
	 */

	// For forms, submit and replace the returned element ID
	$('body').on('submit', 'form[data-ajax]', function(e){
		e.preventDefault();
		var where = $('<div class="ajax-progress">' + $(this).attr('data-ajax') + '</div>').insertAfter(e.currentTarget).animate({left: 0}, 350);
		var replace = $(this).attr('data-replace');
		$.post(window.location.pathname, $(this).serialize(), function(xhr){
			$(where).text('Done');

			if(replace !== '' && $(replace).length){
				$(replace).addClass('updated').html(xhr);

				// Callback when replacing popup cart
				if(replace == '.cart.popup'){
					customDropdown($('form select', replace));
					popupUpdateAppear('#header .mod_navigation li.popup > div.updated');

					var badge = $('.mod_navigation .cart > a').clone().addClass('cart-badge');
					badge.children('.cart-name').remove();
					$('#header .mod_head > a.cart-badge').replaceWith(badge);
				}
			}
		}).fail(function(){

			$(where).text('Failed: retry').siblings('form').removeAttr('data-ajax');

		}).always(function(){

			setTimeout(function(){
				$(where).animate({left: '100%'}, 350, function(){
					$(this).remove();
				});
			}, 3000);

		});
	});

	// For inputs, send field value to attribute href and insert returned html after
	if($('body input[data-ajax]').length){
		// Initalize
		$('body input[data-ajax]').each(function(){
			$(this).parents('p').after('<div class="fayt-results"></div>');
			$(this).parents('p').next('.fayt-results').load($(this).attr('data-ajax') + ' #faq-list', 'q=' + encodeURIComponent($(this).val()), function(){
				$('h2', this).remove();
				$('h5, div.toggler', this).addClass('invisible');
				initAccordion();
			});
		});
	}

	if($('body input[data-search]').length){
		// At page load, update results to enable linking to searches in the URL
		$(window).on('load', function(){
			$('body input[data-search]').trigger('keyup');
		});

		// Search
		$('body input[data-search]').on('keydown', function(e){
			if(e.key == 'Enter' || e.keyCode == 13){
				e.preventDefault();
				return false;
			}
		}).on('keyup', function(e){
			var search_in = $('body input[data-search]').attr('data-search');
			var search = $.trim($(this).val());
			var count = false;

			// Questions
			if(search.length > 2){
				count = $(search_in).find('.category div.toggler').addClass('invisible').filter(function(i){
					var $that = $(this);
					var filter = false;
					$.each(search.toLowerCase().split(' '), function(j, v){
						var regex = new RegExp('\\b' + v, 'i').test($that.text());
						if(v.length > 1 && regex){
							filter = true;
						}
					});
					return filter;
				}).removeClass('invisible');
			}else if($(this).hasClass('hide-when-empty')){
				$(search_in).find('.category div.toggler').addClass('invisible');
			}else{
				$(search_in).find('.category div.toggler').removeClass('invisible');
			}

			// Headline
			if(count && count.length > 0){
				$(search_in).find('h5').removeClass('invisible');
				$(search_in).find('h2').addClass('invisible');
			}else{
				$(search_in).find('h2').removeClass('invisible');
				$(search_in).find('h5').addClass('invisible');
			}
		});
	}

	// For links, load the href and insert returned html after
	if($('body a.product-info').length){
		// Prepare
		$('body a.product-info').each(function(i){
			var url = $(this).attr('href').replace('.html', '').split('/');
			$(this).data('product-info', $('#info-' + url[url.length - 1]));
		});

		// Hover handler
		$('body a.product-info').hover(function(e){
			$(this).off('click');
			var product = $(this).data('product-info');
			if($(product).length){
				$(product).contents().clone().addClass('hover-info list-products').appendTo(this);
			}
		}, function(e){
			$(this).find('.hover-info.list-products').remove();
		});
	}


	/*
	 *  GENERAL: POPUP CAMPAIGN
	 */

	var campaignshown = document.cookie.split(';').filter(function(item){
		return item.indexOf('campaignshown=1') >= 0;
	}).length;

	if($('#sign-up-campaign.popup-active').length && campaignshown <= 0){
		setTimeout(showSubscribePopup, 2000);
	}

	function showSubscribePopup(){
		$.featherlight('#sign-up-campaign', {variant: 'light'});
		document.cookie = 'campaignshown=1;max-age=315360000;Secure;SameSite=None';

		if(typeof ga === 'function'){
			ga('send', 'event', 'advertisement', 'track', 'sign-up-campaign');
		}
	}


	/*
 *  Black Friday CAMPAIGN
 */

	var blackfriday2019 = document.cookie.split(';').filter(function(item){
		return item.indexOf('blackfriday2019=1') >= 0;
	}).length;

	if($('#black-friday-campaign.popup-active').length && blackfriday2019 <= 0){
		setTimeout(showBlackfridayPopup, 2000);
	}

	function showBlackfridayPopup(){
		$.featherlight('#black-friday-campaign', {variant: 'bf-green'});
		document.cookie = 'blackfriday2019=1;max-age=2592000;secure';

		if(typeof ga === 'function'){
			ga('send', 'event', 'advertisement', 'track', 'black-friday-campaign');
		}
	}


	/*
	 *  GENERAL: MEDIA
	 */

	// Video Playlist
	if($('.ytv-list').length){
		$('.ytv-list a').on('click', function(e){
			$('.ytv-list li.ytv-active').removeClass('ytv-active');
			$(e.target).parents('li').addClass('ytv-active');
		});
	}

	// Modal Settings
	if($('.popup-content').length){
		$('.popup-content').addClass('invisible');
	}

	$.featherlight.defaults.loading = '<span id="spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></span>';
	$.featherlight.defaults.afterOpen = function(e){
		$('body').addClass('modal-open');
		$('.featherlight .featherlight-content').attr('tabindex', '-1').focus();
	};
	$.featherlight.defaults.afterClose = function(e){
		$('body').removeClass('modal-open');
	};

	// Image Carousel
	$('.image-viewer').each(function(){
		var imageViewer = $('.viewer', $(this)).addClass('owl-carousel');
		var thumbs = $('.thumbs', $(this)).addClass('owl-carousel');

		imageViewer.owlCarousel({
			items: 1,
			nav: false,
			navSpeed: 1000,
			lazyLoad: true,
			onInitialized: function(e){
				$el = $(e.target);
				$el.parent().attr('role', 'tablist');
				$el.find('.owl-item').each(function(i){
					$(this).attr({
						'id': 'owl-img-' + i,
						'role': 'tabpanel',
						'aria-expanded': 'false'
					});
				}).first().attr('aria-expanded', 'true');
			},
			onTranslated: syncPosition,
		});

		thumbs.owlCarousel({
			items: 8,
			nav: false,
			responsive: {
				480: {items: 4},
				768: {items: 6},
				980: {items: 10},
			},
			dots: false,
			onInitialized: function(e){
				$el = $(e.target);
				$el.find('.owl-item').each(function(i){
					$(this).attr({
						'tabindex': 0,
						'role': 'tab',
						'aria-selected': 'false',
						'aria-controls': 'owl-img-' + i
					});
				}).first().attr('aria-selected', 'true');
				$el.on('click keydown', '.owl-item', function(e){
					if(e.which === 13 || e.type === 'click'){
						e.preventDefault();
						imageViewer.trigger('to.owl.carousel', [$(this).index()]);
					}
				});
			},
		});

		$('.gallery', imageViewer).featherlightGallery({variant: 'gallery'});

		function syncPosition(e){
			var current = e.item.index;
			$(e.target).find('.owl-item').attr('aria-expanded', 'false').eq(current).attr('aria-expanded', 'true');
			thumbs.find('.owl-item').attr('aria-selected', 'false').eq(current).attr('aria-selected', 'true');
			if(thumbs.data('owlCarousel') !== undefined){
				center(current, e.item.count);
			}
		}

		function center(number, thumbsvisible){
			var num = number;
			var found = false;
			for(var i in thumbsvisible){
				if(num === thumbsvisible[i]){
					found = true;
				}
			}

			if(found === false){
				if(num > thumbsvisible[thumbsvisible.length - 1]){
					thumbs.trigger('to.owl.carousel', num - thumbsvisible.length + 2);
				}else{
					if(num - 1 === -1){
						num = 0;
					}
					thumbs.trigger('to.owl.carousel', num);
				}
			}else if(num === thumbsvisible[thumbsvisible.length - 1]){
				thumbs.trigger('to.owl.carousel', thumbsvisible[1]);
			}else if(num === thumbsvisible[0]){
				thumbs.trigger('to.owl.carousel', num - 1);
			}
		}
	});

	// Testimonial Carousel
	if($('.mod_cur_testimonials .list-quotes').length){
		$('.mod_cur_testimonials .list-quotes').addClass('owl-carousel').owlCarousel({
			items: 1,
			nav: false,
			navSpeed: 300,
			onInitialized: function(e){
				$el = $(e.target);
				$el.attr('role', 'tablist');
				$el.find('.owl-dot').each(function(i){
					$(this).attr({
						'tabindex': 0,
						'role': 'tab',
						'aria-selected': 'false',
						'aria-controls': 'owl-quote-' + i
					}).text(i + 1);
				}).first().attr('aria-selected', 'true');
				$el.find('.owl-item').each(function(i){
					$(this).attr({
						'id': 'owl-quote-' + i,
						'role': 'tabpanel',
						'aria-expanded': 'false'
					});
					$('li > div', this).unwrap();
				}).first().attr('aria-expanded', 'true');
			},
			onTranslated: function(e){
				$el = $(e.target);
				$el.find('.owl-dot').attr('aria-selected', 'false').eq(e.item.index).attr('aria-selected', 'true');
				$el.find('.owl-item').attr('aria-expanded', 'false').eq(e.item.index).attr('aria-expanded', 'true');
			},
		});
	}

	// Hero Carousel
	if($('#hero-image .hero-list').length){
		$slides = $('.hero-list').addClass('owl-carousel').owlCarousel({
			items: 1,
			nav: true,
			navSpeed: 300,
			lazyLoad: true,
			autoplay: true,
			autoplayTimeout: 7000,
			autoplayHoverPause: true,
			loop: true,
			onInitialized: function(e){
				$el = $(e.target);
				$el.attr('role', 'tablist');
				$el.find('.owl-dot').each(function(i){
					$(this).attr({
						'tabindex': 0,
						'role': 'tab',
						'aria-selected': 'false',
						'aria-controls': 'owl-hero-' + i
					});
				}).first().attr('aria-selected', 'true');
				$el.find('.owl-item').each(function(i){
					$(this).attr({
						'id': 'owl-hero-' + i,
						'role': 'tabpanel',
						'aria-expanded': 'false'
					});
				}).first().attr('aria-expanded', 'true');
			},
			onTranslated: function(e){
				$el = $(e.target);
				$el.find('.owl-dot').attr('aria-selected', 'false').eq(e.item.index).attr('aria-selected', 'true');
				$el.find('.owl-item').attr('aria-expanded', 'false').eq(e.item.index).attr('aria-expanded', 'true');
			},
		});
	}

	// Automatically fit embedded video players (full width, but correct height)
	$('#container').fitVids();


	/*
	 *  GENERAL: SOCIAL
	 */

	$('.sharing a[target=_blank]').on('click', function(e){
		window.open(this.href, 'share', 'width=640, height=450');
		return false;
	});


	/*
	 *  TABS
	 */

	if($('.tabs').length && $('.tab-nav').length){
		$('.tabs').parent().attr('role', 'tablist');

		$('.tabs > .tab').attr({
			'role': 'tabpanel',
			'aria-expanded': 'false'
		}).first().attr('aria-expanded', 'true');

		$('.tab-nav').removeClass('invisible');
		$('.tab-nav input[type=radio]').each(function(){
			$(this).attr({
				'role': 'tab',
				'aria-controls': $(this).val()
			});
		});
		$('.tab-nav input[type=radio]').on('change', function(e){
			var tabContainer = $('#' + $(this).attr('name'));
			var activeTab = $('.tab.active', tabContainer);
			var targetTab = $('#' + $(this).val());
			activeTab.animate({opacity: 0}, 200);
			targetTab.css('opacity', '0');
			setTimeout(function(){
				activeTab.removeClass('active').attr('aria-expanded', 'false');
				targetTab.addClass('active').attr('aria-expanded', 'true');
				targetTab.animate({opacity: 1}, 200);
			}, 200);
		});
	}


	/*
	 *  GENERAL: RESPONSIVE HEADER
	 */

	var $nav = $('.mod_navigations'),
		navClosed = false;
	var navId = $nav.attr('id');

	if($nav.length && navId === undefined){
		navId = 'nav';
		$nav.attr('id', navId);
	}

	if($(window).width() < 740 && $nav.length){
		$nav.attr('aria-expanded', 'false');
	}

	$('#header .mod_navigations').before('<a href="#" class="toggle-site-menu" aria-controls="' + navId + '">Menu</a>');

	// Clean and insert badge
	var badge = $('.mod_navigation .cart > a').clone().addClass('cart-badge');
	badge.children('.cart-name').remove();
	$('#header .mod_navigations').before(badge);

	$('.toggle-site-menu').on('click', function(e){
		e.preventDefault();
		if($nav.hasClass('expanded')){
			$nav.slideUp().removeClass('expanded').attr('aria-expanded', 'false');
			navClosed = true;
		}else{
			$nav.slideDown().addClass('expanded').attr('aria-expanded', 'true');
			navClosed = false;
		}
	});

	// If the responsive nav was closed, make sure it shows when resizing back up
	$(window).on('resize', function(){
		if($(window).width() > 639){
			if(navClosed){
				// remove inline style attribute so the stylesheet takes over
				$nav.removeAttr('style').removeClass('expanded').removeAttr('aria-expanded');
				navClosed = false;
			}
		}else{
			$nav.attr('aria-expanded', 'false');
		}
	});


	/*
	 *  GENERAL: FORMS
	 */

	function customDropdown(el){
		el.each(function(){
			$(this).wrap('<div class="styled-select"></div>');
			var styledSelect = $(this).parent('.styled-select');
			styledSelect.append('<span class="toggle-select"></span>');
			if($(this).attr('class')){
				styledSelect.addClass($(this).attr('class'));
			}
			if($(this).prop('disabled')){
				styledSelect.addClass('disabled');
			}
			if($(this).prop('multiple')){
				$(this).prop('multiple', false).removeAttr('size');
				$(this).closest('form').data($(this).attr('name'), $(this).find('option').length - 1);
				$('<input type="button" class="multiselect-button" value="+" />').insertAfter(styledSelect).on('click', addMultiSelect);
			}
		});
	}

	function addMultiSelect(e){
		// Check the number of rows allowed
		var selectId = $(e.target).prev('.styled-select').find('select').attr('name');
		var howmany = $(e.target).closest('form').data(selectId);
		if(howmany > 0){
			// Add a new row
			var newrow = $(this).closest('p').clone();
			var newid = 'ctrl' + Math.round(new Date().getTime() + (Math.random() * 100)).toString().substr(7);
			$('label', newrow).attr('for', newid);
			$('select', newrow).attr('id', newid);
			$('.multiselect-button', newrow).on('click', addMultiSelect);
			$(this).closest('p').after(newrow);
			$(this).closest('form').data(selectId, howmany - 1);

			$(this).val('-').off('click').on('click', removeMultiSelect);
		}
	}

	function removeMultiSelect(e){
		var selectId = $(e.target).prev('.styled-select').find('select').attr('id');
		$(this).closest('form').data(selectId, $(this).closest('form').data(selectId) + 1);
		$(this).closest('p').remove();
	}

	function customInputs(el){
		el.each(function(){
			$(this).parent().addClass('control');
			if(!$(this).closest('.no-indicator').length){
				$(this).next('label').append('<span class="control-indicator"></span>');
			}
		});
	}

	// Use custom dropdown
	customDropdown($('form select'));

	// Use custom checkbox and radio
	customInputs($('form input[type=checkbox], form input[type=radio]'));

	$('#eula').removeClass('control').addClass('eula');
	$('#eula label').removeClass('control-indicator').addClass('eula');

	// Submit form from textarea
	$('form textarea').on('keydown', function(e){
		if(e.defaultPrevented){
			return;
		}

		if((e.key == 'Enter' || e.keyCode == 13) && (e.metaKey || e.ctrlKey)){
			this.form.submit();
		}
	});

	// Submit form when changing quantity
	$(document).on('change', 'form.quantity select', function(e){
		this.form.submit();
	});

	// Show other option when applicable
	$('form input[type=text].other').each(function(){
		if($(this).parent().prev().find('select').val() != 'other' && $(this).parent().prev().find('select').val() != 'zz_other'){
			$(this).parent().hide();
		}

		var that = this;
		$(this).parent().prev().find('select').on('change', function(){
			if(!$(that).parent().is(':visible') && ($(this).val() == 'other' || $(this).val() == 'zz_other')){
				$(that).parent().slideToggle();
			}else if($(that).parent().is(':visible') && ($(this).val() != 'other' || $(this).val() != 'zz_other')){
				$(that).parent().slideToggle();
			}
		});
	});

	// Show counter on textareas
	$('form textarea.counter').each(function(){
		var max = $(this).attr('maxlength');
		if(max !== '' && $.isNumeric(max)){
			// TODO: Live regions
			$(this).after('<span class="counter" aria-live="polite">' + $(this).val().length + '/' + max + '</span>');
			$(this).on('keyup input', function(e){
				$(this).next('span.counter').text($(this).val().length + '/' + max);
			});
		}
	});

	// Solid rating stars on selection
	$('form fieldset.rating input[type=radio]').on('change', function(e){
		var allOptions = $('input[name="' + $(this).attr('name') + '"]');
		var inactiveOptions = $('#' + $(this).attr('id') + ' ~ input');
		allOptions.addClass('active');
		inactiveOptions.removeClass('active');
	});
	$('form fieldset.rating input[type="radio"]:checked').trigger('change');

	// Prepare validator: add pattern attribute and set defaults
	$.validator.addMethod('pattern', function(value, element){
		var pattern = new RegExp($(element).attr('pattern'));
		var test = pattern.test(value);
		return this.optional(element) || test;
	});
	$.validator.setDefaults({
		errorElement: 'span',
		errorClass: 'message message-error',
		errorPlacement: function(error, element){
			element.parents('p').append(error);
		},
		highlight: function(element, errorClass){
			$(element.form).find('label[for=' + element.id + ']').addClass('error');
		},
		unhighlight: function(element, errorClass){
			$(element.form).find('label[for=' + element.id + ']').removeClass('error');
		}
	});

	// Password strength meter
	if($('#ctrl_password').length && $('#ctrl_password_confirm').length){
		var $ctrl = $('#ctrl_password').attr('aria-describedby', 'ctrl_password_meter');
		$ctrl.parent().append('<div id="ctrl_password_meter" class="password-meter" aria-live="polite"><div class="password-meter-message">&nbsp;</div><div class="password-meter-bg"><div class="password-meter-bar"></div></div></div>');
		$ctrl.closest('form').validate();
		$ctrl.valid();
	}
	// Form validation
	else if($('.ce_form form').length){
		$('.ce_form form').validate();
	}

	if($('.activate-machine form').length){
		$('.activate-machine form').validate();
	}
	if($('.activate-new-machine form').length){
		$('.activate-new-machine form').validate();
	}

	// Confirmation messages
	if($('input[data-confirm]').length){
		$('input[data-confirm]').each(function(){
			var text = '<p>' + $(this).attr('data-confirm') + '</p>';
			if($(this).hasClass('confirm')){
				var form = $(this).removeAttr('data-confirm').parents('form').prop('outerHTML');
				$(this).featherlight(text + form);
			}else if($(this).hasClass('inactive')){
				$(this).featherlight(text);
			}
		});
	}

	// Progress indicator on submit
	if($('body.checkout #main form input[type=submit]').length){
		$('body.checkout #main form input[type=submit]').closest('form').on('submit', function(e){
			if(!e.isDefaultPrevented() && $(e.target).attr('target') != '_blank'){
				showProgressAnimation();
			}
		});
	}


	/*
	 *  GENERAL: HEADER POPUPS
	 */

	var $popups = $('#header .mod_navigation li.popup');

	if($popups.length){
		// If page is refreshing because of an updated popup and is not mobile
		if($(window).width() > 639 && $popups.children('div.updated').length){
			popupUpdateAppear($popups.children('div.updated'));
		}

		$popups.each(function(i){
			var popupContent = $(this).children('div').attr('aria-expanded', 'false');
			var popupId = popupContent.attr('id');

			if(popupId === undefined){
				popupId = 'popup-' + i;
				popupContent.attr('id', popupId);
			}

			$(this).children('a').attr('aria-controls', popupId);
		});

		// Open popup from link
		$popups.on('click', '> a', function(e){
			if($(window).width() > 639){
				e.preventDefault();
				if($(this).parent('li.popup').hasClass('expanded')){
					popupDisappear('li.popup > div');
				}else{
					popupDisappear('li.popup > div', $(this).next('div'));
					popupAppear($(this).next('div'));
				}
			}
		});

		// Close popup when clicking outside it
		$(document).click(function(e){
			if(!$(e.target).closest('li.popup').length && !$(e.target).hasClass('notification')){
				popupDisappear('li.popup > div');
			}
		});
	}

	// When the window is sized to mobile, hide the popups
	$(window).on('resize', function(){
		if($(window).width() < 740 && $popups.filter('.expanded').length){
			popupDisappear('li.popup > div');
		}
	});

	function popupAppear(el){
		$(el).css('opacity', 0).parent('li.popup').addClass('expanded');
		$(el).animate({opacity: 1}, 200).attr('aria-expanded', 'true');
	}

	function popupUpdateAppear(el){
		popupAppear(el);

		// Fade out popup after a delay if user has not clicked on it
		popupUpdatedDisappear = setTimeout(function(){
			popupDisappear(el);
			$(el).removeClass('updated');
		}, 3800);

		// Cancel fade out if hover or click on popup
		$(el).one('mouseenter click', function(){
			popupCancelDisappear(this);
		});
	}

	function popupDisappear(el, exclude){
		if(typeof exclude !== undefined){
			$el = $(el).not(exclude);
		}else{
			$el = $(el);
		}

		$el.animate({opacity: 0}, 200, function(){
			$el.parent('li.popup').removeClass('expanded').removeClass('modal');
		}).attr('aria-expanded', 'false');
	}

	function popupCancelDisappear(el){
		if(typeof popupUpdatedDisappear !== undefined){
			clearTimeout(popupUpdatedDisappear);
		}
		$(el).removeClass('updated');
	}


	/*
	 *  PAGE: PRODUCTS
	 */

	if($('body.products').length){

		// Set up
		product_list = '.mod_cur_productlist';
		initFilter('product');
		updateCategories();

		// Count products
		$('.product-category').each(function(){
			var countProducts = $('.list-products > li', this).length;
			$(this).attr('data-products-total', countProducts);
		});

		// Selecting a filter or sort option
		$('input[type=checkbox], input[type=radio]', '#filters').on('change', function(e){
			e.preventDefault();
			applyFilter('product');
			updateUrl(true);
		});

		$('#sort input[type=radio]').on('change', function(e){
			e.preventDefault();
			applySort();
			updateUrl(true);
		});

		// Reset buttons
		$('#RESET_FILTER_SORT, .error-none-enabled .button').on('click', function(e){
			e.preventDefault();
			resetFilter('product');
			updateUrl(true);
		});

	}

	// Countdown clock
	if($('.ce_countdown').length){
		var date = $('.ce_countdown').attr('data-date');
		$('.ce_countdown .counter').attr('role', 'timer').countdown({
			until: new Date(date * 1000),
			format: 'HMS'
		});
	}


	/*
	 *  PAGE: PICKPACK
	 */

	if($('body.pick-pack').length){

		// Set up
		product_list = '#pick-pack-products';
		$.featherlight.defaults.afterContent = function(){
			featherlight_form = '.featherlight form';
			initFilter('product');
			customInputs($('input[type=checkbox], input[type=radio]', featherlight_form));
			addMobilePageNav();

			// Selecting a filter or sort option
			$('input[type=checkbox], input[type=radio]', '#filters').on('change', function(e){
				e.preventDefault();
				applyFilter('product');
				updateUrl(true, false);
			});

			$('#sort input[type=radio]').on('change', function(e){
				e.preventDefault();
				applySort();
				updateUrl(true, false);
			});

			// Reset button
			$('#RESET_FILTER_SORT, .error-none-enabled .button').on('click', function(e){
				e.preventDefault();
				resetFilter('product');
				updateUrl(true, false);
			});

			// Counter
			$('input[type=checkbox]', product_list).on('change', function(e){
				var $selectedOptions = $('input[name="products[]"]:checked'),
					$max = $('.page-actions p[data-max]', featherlight_form),
					$counter = $('.page-actions p[data-add]', featherlight_form),
					$button = $('.page-actions input[type=submit]', featherlight_form);
				var add = $max.attr('data-max') - $selectedOptions.length;
				if(add < 0){
					$counter.text($counter.attr('data-remove').replace('{0}', Math.abs(add)));
					$button.prop('disabled', true);
				}else{
					$counter.text($counter.attr('data-add').replace('{0}', add));
					$button.prop('disabled', false);
				}
			});

			// Progress indicator on submit
			$('input[type=submit]', featherlight_form).closest('form').on('submit', function(e){
				if(!e.isDefaultPrevented() && $(e.target).attr('target') != '_blank'){
					$('<div id="blanket" role="progressbar"><span id="spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></span></div>')
						.appendTo('body').hide().fadeIn('fast');
				}
			});
		};

	}


	/*
	 *  FILTER UTILITIES
	 */

	function initFilter(which){

		// Set up
		updateSelectedFacetOptions();
		$('#SUBMIT_FILTER_SORT').addClass('invisible');

		// Clicks outside a dropdown should close it
		$(document).click(function(e){
			if(!$(e.target).closest('.filter-facets fieldset').length){
				closeOpenFilters();
			}
		});

		// Handle popstate
		$(window).on('popstate', function(e){
			// Go to the top of the page because that is where IAS loaded the content from the last scroll position
			$.smoothScroll({
				scrollTarget: $('.mod_newslist:not(.featured):first'),
				offset: pageOffset,
				speed: 100
			});
		});

		// Dropdown options menus
		$('.filter-facets legend').each(function(i){
			var $options = $(this).next('.facet-options');
			var optionsId = $options.attr('id');

			if($options.length && optionsId === undefined){
				optionsId = 'options_' + i;
				$options.attr('id', optionsId);
			}

			$(this).attr({
				'aria-controls': optionsId
			});
		});
		$('.facet-options').attr('aria-expanded', 'false').css({
			'display': 'none',
			'max-height': $(window).height() - 130
		});
		$('.filter-facets fieldset, fieldset.filter-facets').on('click', function(e){
			var target = $(e.target),
				facetOptions;

			// close any open filters
			closeOpenFilters();

			if(target.parents('.facet-options').length){
				facetOptions = target.parents('.facet-options').eq(0);
			}else{
				facetOptions = $('.facet-options', this);
				if(facetOptions.length){
					if(!facetOptions.hasClass('expanded')){
						// Open the facet option dropdown
						facetOptions.fadeIn(200, function(){
							facetOptions.addClass('expanded').attr('aria-expanded', 'true');
						});
					}else{
						// Close the facet option dropdown
						facetOptions.fadeOut(200, function(){
							facetOptions.removeClass('expanded').attr('aria-expanded', 'false');
						});
					}
				}
			}
		});
		$('input[type=checkbox], input[type=radio]', '.filter-facets').on('focus', function(e){
			var openFacetOptions = $('.facet-options.expanded');
			var facetOptions = $(e.target).parents('.facet-options');

			if(openFacetOptions !== facetOptions){
				// close any open filters
				closeOpenFilters();

				// Open the facet option dropdown
				facetOptions.stop().fadeIn(200, function(){
					facetOptions.addClass('expanded').attr('aria-expanded', 'true');
				});
			}
		});

	}

	function applyFilter(which){

		var scrollToTop = false;

		// close any facet-options menus and update selection
		closeOpenFilters();
		updateSelectedFacetOptions();

		// process all enabled filters
		// skip selected options that are used to show all (no value)
		var enabledFacets = $('input[type=checkbox]:checked:not([value=""]), input[type=radio]:checked:not([value=""])', '#filters');

		// News filter
		if(which == 'news'){
			target = $('#main .inside > div:first').attr('id');
			if(enabledFacets.length > 0){
				query = enabledFacets.serialize() + '&SUBMIT_FILTER_SORT=1';
			}else{
				query = 'RESET_FILTER_SORT=Reset';
			}

			$('#' + target).parent().load(window.location.pathname + ' #' + target, query, function(){
				// Reinitalize the ias
				if(typeof ias !== undefined){
					ias.reinitialize();
				}
			});

			return;
		}

		// Products filter if a facet is enabled
		if(enabledFacets.length > 0){
			scrollToTop = true;
			// enable filtering
			$(product_list).addClass('filtered');
			var includedProducts = $('.list-products > li', product_list);

			enabledFacets.each(function(){
				var thisFilter = $(this).val();
				if(thisFilter !== ''){
					var thisFilterType = $(this).attr('data-filter');
					includedProducts = includedProducts.filter('[data-' + thisFilterType + '*="[' + thisFilter + ']"]');
				}
			});

			// cleanup: fade in matched products, hide products that don't match
			var excludedProducts = $('.list-products > li', product_list).not(includedProducts);
			includedProducts.animate({opacity: 1}, 200);
			includedProducts.addClass('enabled');
			excludedProducts.animate({opacity: 0}, 200);
			setTimeout(function(){
				excludedProducts.removeClass('enabled');
				updateCategories();
			}, 100);

		}else{
			// Remove all filtering
			$(product_list).removeClass('filtered');
			$('.list-products > li', product_list).addClass('enabled');
			$('.list-products > li.enabled', product_list).animate({opacity: 1}, 200);
			updateCategories();
		}

		// Option: also scroll to top of products at the same time
		if(scrollToTop){
			$.smoothScroll({
				offset: pageOffset,
				scrollTarget: $(product_list)
			});
		}

	}

	function applySort(){

		// close any facet-options menus and update selection
		closeOpenFilters();
		updateSelectedFacetOptions();

		// get selected sort option
		var sortFunction = $('#sort input[type=radio]:checked').val();

		// iterate over products
		$('.list-products', product_list).each(function(){
			$(this).children('li').sort(function(a, b){
				if(sortFunction == 'manufacturerAZ'){
					return ($(a).find('.product-manufacturer').text().toLowerCase() + ' ' + $(a).find('.product-title').text().toLowerCase()).localeCompare($(b).find('.product-manufacturer').text().toLowerCase() + ' ' + $(b).find('.product-title').text().toLowerCase());
				}else if(sortFunction == 'manufacturerZA'){
					var compare = $(b).find('.product-manufacturer').text().toLowerCase().localeCompare($(a).find('.product-manufacturer').text().toLowerCase());
					if(compare === 0){
						return $(a).find('.product-title').text().toLowerCase().localeCompare($(b).find('.product-title').text().toLowerCase());
					}
					return compare;
				}else if(sortFunction == 'productAZ'){
					return $(a).find('.product-title').text().toLowerCase().localeCompare($(b).find('.product-title').text().toLowerCase());
				}else if(sortFunction == 'productZA'){
					return $(b).find('.product-title').text().toLowerCase().localeCompare($(a).find('.product-title').text().toLowerCase());
				}else if(sortFunction == 'priceHL'){
					return parseInt($(b).attr('data-price'), 10) - parseInt($(a).attr('data-price'), 10);
				}else if(sortFunction == 'priceLH'){
					return parseInt($(a).attr('data-price'), 10) - parseInt($(b).attr('data-price'), 10);
				}else if(sortFunction == 'mostPopular'){
					return parseInt($(a).attr('data-popular'), 10) - parseInt($(b).attr('data-popular'), 10);
				}else if(sortFunction == 'topRated'){
					var ratingOrder = parseFloat($(b).attr('data-rating'), 10) - parseFloat($(a).attr('data-rating'), 10);
					if(ratingOrder === 0){
						return $(a).find('.product-title').text().toLowerCase().localeCompare($(b).find('.product-title').text().toLowerCase());
					}
					return ratingOrder;
				}
			}).appendTo(this);
		});

	}

	function updateFilterFromUrl(which){

		resetFilter(which);

		// Check query string for filter and sort
		var filters = [
				'man',
				'category',
				'formats',
				'flags',
				'author',
				'artist',
				'product',
				'type',
				'genre',
				'job_title'
			],
			sort = getUrlParameter('sort'),
			filter,
			$input;

		filters.forEach(function(item){
			filter = getUrlParameter(item);
			$input = $('.filter-facets input[data-filter="' + item + '"]');
			if(filter.isArray()){
				$.each(filter, function(i){
					$input.filter(function(){
						return this.value.toLowerCase().indexOf(filter[i].toLowerCase()) >= 0;
					}).prop('checked', true);
				});
			}else if(filter){
				$input.filter(function(){
					return this.value.toLowerCase() == filter.toLowerCase();
				}).prop('checked', true);
			}
		});

		if(sort){
			$('.filter-facets input[name="sort"]').filter(function(){
				return this.value.toLowerCase() == sort.toLowerCase();
			}).prop('checked', true);

			applySort();
		}

		applyFilter(which);
	}

	// Reset the selected states of all options
	function resetFilter(which){
		$('#filters .filter-facets fieldset > .facet-options input[type=checkbox]').prop('checked', false);
		$('#filters .filter-facets fieldset > .facet-options').find('li:first input[type=radio]').prop('checked', true);
		applyFilter(which);
	}

	// Send ajax request to update filter and sort options on the server and
	// add URL to browser history
	function updateUrl(sendget, history){
		var $enabledFacets = $('input[type=checkbox]:checked:not([value=""]), input[type=radio]:checked:not([value=""])', '#filters, #sort'),
			pageTitle = document.title? document.title: window.location.href,
			query = $enabledFacets.length? '?' + $enabledFacets.serialize(): '',
			url = $enabledFacets.closest('form').attr('action') + query;

		if(sendget || sendget === undefined){
			$.get(url);
		}
		if(history || history === undefined){
			window.history.pushState(null, pageTitle, url);
		}
	}

	function updateCategories(){
		$('#page-toolbar .page-nav a').removeClass('disabled').removeAttr('aria-disabled');
		$('.product-category', product_list).each(function(){
			var countEnabled = $('.list-products > li.enabled', this).length;
			$(this).attr('data-products-enabled', countEnabled);

			// Show product count
			if(countEnabled === 0){
				$('#page-toolbar .page-nav a[href*=' + $(this).attr('id') + ']').addClass('disabled').attr('aria-disabled', 'true');
			}
		});
		if($('.list-products > li.enabled', product_list).length < 1){
			$('.error-none-enabled', product_list).css('opacity', 0);
			setTimeout(function(){
				$(product_list).addClass('none-enabled');
				$('.error-none-enabled', product_list).animate({opacity: 1}, 300);
			}, 100);
		}else{
			$(product_list).removeClass('none-enabled');
		}
	}

	function closeOpenFilters(){
		var openFacetOptions = $('.facet-options.expanded');
		if(openFacetOptions.length > 0){
			openFacetOptions.fadeOut(200, function(){
				openFacetOptions.removeClass('expanded').attr('aria-expanded', 'false');
			});
		}
	}

	// If a facet option is enabled, use selected style for popup (update text or just highlight)
	// including when facet option is set by a URL parameter at page load
	function updateSelectedFacetOptions(){
		var facetOptions = $('.facet-options');
		facetOptions.each(function(){
			var facet = $(this).closest('.filter-facets fieldset');

			// Use text of active facet option for label
			if($('legend.update', facet).length){
				var enabledFacetText = $('input:checked + label', facet).text();
				$('legend.update', facet).text(enabledFacetText + ' ▾');
			}
			// Add enabled highlight to facet
			else if($('input:checked', facet).val() !== '' && $('input:checked', facet).length !== 0){
				facet.addClass('option-selected');
			}
			// Remove enabled highlight from facet
			else{
				facet.removeClass('option-selected');
			}

		});
	}

	function getUrlParameter(getKey, url){
		var urlVariables = [],
			returnValue = null;

		if(typeof url != 'undefined'){
			if(url.split('?')[1] !== undefined){
				urlVariables = url.split('?')[1].split('&');
			}
		}else{
			urlVariables = window.location.search.slice(1).split('&');
		}

		for(var i = 0; i < urlVariables.length; i++){
			var keyAndValue = urlVariables[i].split('=');
			if(keyAndValue[0] == getKey && keyAndValue[1].indexOf(',') >= 0){
				returnValue = keyAndValue[1].split(',');
			}else if(keyAndValue[0] == getKey){
				returnValue = keyAndValue[1];
			}else if(decodeURIComponent(keyAndValue[0]) == getKey + '[]'){
				if(returnValue === null){
					returnValue = [];
				}
				returnValue.push(keyAndValue[1]);
			}
		}
		return returnValue;
	}


	/*
	 *  SECTION: MOBILE JUMP TO MENU
	 */

	function initPageNav(){
		if($(window).width() < 800){
			$('.page-nav-label').attr({'tabindex': '0'});
			$('.page-nav-label').next('ul').attr('aria-expanded', 'false');
		}else{
			$('.page-nav-label').removeAttr('tabindex');
			$('.page-nav-label').next('ul').removeClass('expanded').removeAttr('aria-expanded');
		}
	}

	if($('.page-nav-label').length){
		// When the window is sized to mobile, remove the popups becasue the nav is shown
		$(window).on('resize', initPageNav);
		initPageNav();
		addMobilePageNav();
	}

	function addMobilePageNav(){
		$('.page-nav-label').each(function(i){
			var $controls = $(this).next('ul, .filter-facets');
			var controlsId = $controls.attr('id');

			if($controls.length && controlsId === undefined){
				controlsId = 'page_nav_' + i;
				$controls.attr('id', controlsId);
			}

			$(this).attr({
				'aria-controls': controlsId
			}).on('click keydown', function(e){
				if($(window).width() < 800 && (e.which === 13 || e.type === 'click')){
					$controls.slideToggle().toggleClass('expanded');
					if($controls.hasClass('expanded')){
						$controls.attr('aria-expanded', 'true');
					}else{
						$controls.attr('aria-expanded', 'false');
					}
				}
			});
		});

		$('.page-nav-label + ul a:not(.disabled)').on('click', function(){
			if($(window).width() < 800){
				$(this).closest('ul').slideToggle();
			}
		});
	}


	/*
	 *  PAGE: PRODUCT DETAIL
	 */

	if($('.product #downloads, .order-success #downloads').length){
		$('#downloads .group:not(.manuals) a').on('click', function(e){
			e.preventDefault();
			var url = this.href;
			$.ajax('/en/downloads.html').done(function(){
				window.location = url;
				return true;
			}).fail(function(){
				// Show popup centered
				$('#header .mod_navigation li.popup.login').addClass('modal');

				if($(window).width() > 639){
					$('#header .mod_navigation li.popup.login > a').trigger('click');
				}else{
					$nav.slideDown(function(){
						var $el = $('#header .mod_navigation li.popup.login').addClass('expanded');
						$el.children('div').css('opacity', 0).animate({opacity: 1}, 200).attr('aria-expanded', 'true');
					}).addClass('expanded').attr('aria-expanded', 'true');
				}

				// Change form action and show explanation
				$('#header .mod_navigation li.popup.login form').attr('action', function(i, val){
					if(val.indexOf('#downloads') == -1){
						return val + '#downloads';
					}
				}).prepend($('#downloads .invisible.message').removeClass('invisible')).find('input:visible:first').focus();

			});
		});
	}


	/*
	 *  PAGE: MANAGE PLUGINS & DEVICES
	 */

	if($('#license-filter').length){
		$('#license-filter input[type=checkbox]').on('change', function(){
			var what = $(this).val();
			$.post(window.location.pathname, $('#license-filter').serialize());
			if($(this).is(':checked')){
				// If one of the licenses to hide is expanded, close it first
				if($('body.manage-plugins').length){
					$('.toggler.' + what + '[aria-expanded=true] + .accordion').slideUp();
					$('.toggler.' + what + '[aria-expanded=true]').removeClass('active').attr('aria-expanded', 'false');
					$('.toggler.' + what).slideUp(function(){
						$('#license-filter').parent().addClass(what);
					});
				}else{
					$('.deactivate-machine .' + what).fadeOut(function(){
						$('#license-filter').parent().addClass(what);
					});
				}
			}else{
				if($('body.manage-plugins').length){
					$('#license-filter').parent().removeClass(what);
					$('.toggler.' + what).slideDown();
				}else{
					$('.deactivate-machine .' + what).fadeIn(function(){
						$('#license-filter').parent().removeClass(what);
					});
				}
			}
		});
	}


	/*
	 *  SECTION: CHECKOUT
	 */

	// inline edit billing addresss
	if($('#my_cart_billing_information').length && $('#edit-billing').length){
		$(window).keydown(function(event){
			if(event.keyCode === 13) {
				event.preventDefault();
				return false;
			}
		});

		var button = $('#edit-billing');
		var instructions = $('.readonly');
		var inputs = $('#my_cart_billing_information p input');
		var selects = $('#my_cart_billing_information select');
		var payment = $('#my_cart_payment_method');
		var pay_buttons = $('#submit-method-credit, #submit-method-paypal');
		if(inputs.first().prop('readonly')){
			button.data('editmode', 'inactive');
		}
		button.on('click', function(e){
			if(button.data('dosubmit') === true || !pay_buttons.length){
				// Allow default button action
			}else if(button.data('editmode') === 'inactive'){
				e.preventDefault();
				instructions.removeClass('invisible');
				inputs.prop('readonly', false);
				selects.prop('disabled', false);
				selects.parent().removeClass('disabled');
				button.val(button.attr('data-active'));
				button.data('editmode', 'active');
				payment.slideUp();
				pay_buttons.addClass('invisible');

				if (typeof initAutocomplete === 'function') {
					initAutocomplete();
				}
			}else{
				e.preventDefault();
				instructions.addClass('invisible');
				$('#my_cart_billing_information .message-error').addClass('invisible');
				inputs.prop('readonly', true);
				selects.prop('disabled', true);
				selects.parent().addClass('disabled');
				button.val(button.attr('data-inactive'));
				button.data('editmode', 'inactive');
				payment.slideDown();
				pay_buttons.removeClass('invisible');
			}
		});

		// require re-submit when country and VAT are changed or there are any errors
		selects.on('change', function(){
			button.attr('name', 'SUBMIT_ADDRESS_INFORMATION');
			button.data('dosubmit', true);
		});

		$('#billing_address_tax_number').on('change', function(){
			button.attr('name', 'SUBMIT_ADDRESS_INFORMATION');
			button.data('dosubmit', true);
		});

		$('#billing_address_state').on('change', function(){
			button.attr('name', 'SUBMIT_ADDRESS_INFORMATION');
			button.data('dosubmit', true);
		});

		if($('#my_cart_billing_information .error').length){
			button.attr('name', 'SUBMIT_ADDRESS_INFORMATION');
			button.data('dosubmit', true);
		}

		// enable country on submit
		if($('select:disabled').length){
			$('form').on('submit', function(){
				$('select:disabled').prop('disabled', false);
			});
		}
	}

	// toggle credit card form
	if($('.payment-method').length){
		$(window).on('load', {init: true}, updatePaymentMethod);
		$('input[name=payment-method]').on('change', {init: false}, updatePaymentMethod);
	}

	function updatePaymentMethod(args){
		var paymentMethod = $('input[name=payment-method]:checked', 'form').val();
		if(paymentMethod == 'checkout_express'){
			if(args.data.init){
				$('#payment-method-credit').hide();
			}else{
				$('#payment-method-credit').slideUp();
			}
			$('#submit-method-credit').hide();
			$('#submit-method-paypal').show();
		}else if(paymentMethod == 'checkout_cardstored'){
			if(args.data.init){
				$('#payment-method-credit').hide();
			}else{
				$('#payment-method-credit').slideUp();
			}
			$('#submit-method-credit').show();
			$('#submit-method-paypal').hide();
		}else{
			if(args.data.init){
				$('#payment-method-credit').show();
			}else{
				$('#payment-method-credit').slideDown();
			}
			$('#submit-method-credit').show();
			$('#submit-method-paypal').hide();
		}
	}

	// insert installment detail lightbox links
	if($('#my_cart_installment').length){
		$('.listall, .existing, .missing').each(function(){
			var lightboxLink = $(this).next().attr('id');
			var lightboxText = $(this).attr('data-text');
			$(this).append(' <a href="#' + lightboxLink + '" data-featherlight>' + lightboxText + '</a>');
		});
	}


	/*
	 *  SECTION: MANUFACTURER LIST
	 */

	if($('.toggling .list-members').length){
		$('.list-members > li').each(function(){

			// Create an excerpt, and a Read More button, if description is long
			var excerptLength = 400;

			var description = $('.member-description', this);
			var descriptionContent = description.html();
			var descriptionId = description.attr('id');

			if(description.length && descriptionId === undefined){
				descriptionId = 'description_' + $(this).attr('id');
			}

			if(descriptionContent.length > (excerptLength - 1)){
				description.html('');
				var descriptionExcerpt = descriptionContent.substring(0, excerptLength);

				description.append('<div class="excerpt">' + descriptionExcerpt + '&hellip;</div>');
				$('<div class="full">' + descriptionContent + '</div>').appendTo(description).hide();
				description.addClass('collapsed').attr({
					'id': descriptionId,
					'aria-expanded': 'false'
				});

				$('.member-actions', this).prepend('<a href="#" class="button expand-toggle" aria-controls="' + descriptionId + '">Read More</a>');
			}

		});
		$('a.expand-toggle').on('click', function(e){
			e.preventDefault();
			var description = $(this).parentsUntil('.list-members').children('.member-description');

			// Hide excerpt and show full when this description is collapsed
			if(description.hasClass('collapsed')){
				$('.excerpt', description).slideUp();
				$('.full', description).slideDown();
				$(this).text('Read Less');
				description.removeClass('collapsed').addClass('expanded').attr('aria-expanded', 'true');
			}
			// Show excerpt and show full when this description is expanded
			else{
				$('.full', description).slideUp();
				$('.excerpt', description).slideDown(function(){
					if(!$(e.target).parentsUntil('.list-members').visible()){
						$('body, html').animate({scrollTop: $(e.target).parentsUntil('.list-members').offset().top}, 200);
					}
				});
				$(this).text('Read More');
				description.removeClass('expanded').addClass('collapsed').attr('aria-expanded', 'false');
			}
		});
	}


	/*
	 *  SECTION: YOUTUBE SUBSCRIBE BUTTON
	 */

	if($('.g-ytsubscribe').length){
		$.ajaxSetup({cache: true});
		$.getScript('https://apis.google.com/js/platform.js');
	}


	/*
	 *  SECTION: GLEAM
	 */

	if($('a[href*="//gleam.io/"]').length){
		$.ajaxSetup({cache: true});
		$.getScript('https://js.gleam.io/e.js');
	}


	/*
	 *  SECTION: FACEBOOK COMMENTS
	 */

	if($('div.fb-comments').length){
		/*! Facebook SDK with jQuery | https://developers.facebook.com/docs/javascript/howto/jquery
			for Social Comments Plugin | developers.facebook.com/docs/plugins/comments */
		$.ajaxSetup({cache: true});
		$.getScript('https://connect.facebook.net/en_US/sdk.js', function(){
			FB.init({
				appId: '570178263033776', // App ID
				version: 'v3.1',
				status: true, // check login status
				cookie: true, // enable cookies to allow the server to access the session
				oauth: true, // enable OAuth 2.0
				xfbml: true // parse XFBML
			});
		});
	}


	/*
	 *  PAGE: XMAS CALENDAR
	 */

	if($('body #xmas').length){
		// At page load, open xmas lightbox from page URL, if any
		$(window).on('load', function(){
			var wheretogo = '#door' + getUrlParameter('door');
			if(wheretogo !== '' && $(wheretogo).length){
				if(isMobile){
					$.smoothScroll({
						scrollTarget: wheretogo,
						offset: pageOffset,
						speed: 400
					});
				}else{
					$.featherlight(wheretogo);
				}
			}
		});

		// Disable lightbox links on mobile
		if(isMobile){
			$('a[data-featherlight]').removeAttr('data-featherlight');
		}
	}


	/*
	 *  RESPONSIVE UTILITIES
	 */

	var isMobile;

	function updateResponsiveLayout(){
		if($(window).width() > 800){
			// reset any styles applied if mobile menu was opened
			$('.filter-facets').css('display', '');
			$('.page-nav-label + ul').css('display', '');
			isMobile = false;
		}else{
			isMobile = true;
		}
	}


	/*
	 *  SECTION: ACCORDION
	 */

	function initAccordion(){
		var allQuestions = $('div.toggler');
		var allAnswers = $('div.accordion');

		$('div.category').attr({
			'role': 'tablist',
			'aria-orientation': 'vertical'
		});

		allAnswers.hide().each(function(i){
			var answerId = $(this).attr('id');

			if(answerId === undefined){
				answerId = 'accordion_' + i;
			}

			$(this).attr({
				'id': answerId,
				'role': 'tabpanel',
				'aria-expanded': 'false'
			});
		});

		allQuestions.each(function(i){
			$(this).attr({
				'tabindex': 0,
				'role': 'tab',
				'aria-selected': 'false',
				'aria-controls': $(this).next('div.accordion').attr('id')
			});
		}).on('click keypress', function(e){
			if(e.which === 13 || e.type === 'click'){
				allAnswers.slideUp().attr('aria-expanded', 'false');
				allQuestions.removeClass('active').attr('aria-selected', 'false');
				if($('body').data('currentQ') != $(e.target).closest('.toggler').attr('id')){
					$('body').data('currentQ', $(e.target).closest('.toggler').attr('id'));
					$(this).addClass('active').attr('aria-selected', 'true').next('div.accordion').slideDown(function(){
						if(!$(e.target).visible()){
							$('body, html').animate({scrollTop: $(e.target).offset().top}, 200);
						}
					}).attr('aria-expanded', 'true');
					if(typeof ga === 'function'){
						ga('send', 'event', 'nav', 'faq', $(e.target).closest('.toggler').attr('id'));
					}
				}else{
					$('body').data('currentQ', null);
				}
			}
		});
	}

	if($('div.toggler').length){
		initAccordion();
	}


	/*
	 *  PAGE: TECH SUPPORT
	 */

	if($('form select[name="plugin[]"]').length){
		$('form').on('change', 'select[name="plugin[]"]', checkPluginValue);
	}

	function checkPluginValue(){
		var selected = $('select[name="plugin[]"]').map(function(){
			return this.value;
		}).get();

		if($(selected).not($(['none', 'all', 'other'])).length > 0){
			$('input[name=version]').parent().slideDown();
		}else{
			$('input[name=version]').parent().slideUp();
		}
	}


	/*
	 *  GOOGLE ANALYTICS
	 */
	// ga('send', 'event', [eventCategory], [eventAction], [eventLabel], [eventValue]);

	// Download links
	$('.downloads a').on('click', function(){
		if(typeof ga === 'function'){
			ga('send', 'event', 'link', 'click', this.href);
		}
	});

	// Anchor links
	$('a[href^="#"]').on('click', function(){
		var fragment = this.href.split('#');
		if(fragment[1] !== ''){
			ga('send', 'event', 'nav', 'click', fragment[1]);
		}
	});

	// Email links
	$('a[href^=mailto]').on('click', function(){
		var fragment = this.href.replace('mailto:', '').split('?');
		ga('send', 'event', 'link', 'click', fragment[0]);
	});

	// Social share
	$('.sharing a[target=_blank]').on('click', function(){
		ga('send', 'event', 'share', this.text, window.location.href);
	});

	// Product media tabs
	$('.tab-nav input[type=radio]').on('change', function(){
		ga('send', 'event', 'nav', 'product ' + this.value.replace('-', ' '), window.location.href);
	});

	// Product links
	$('.list-products a').on('click', function(e){
		var productid = $(this).parents('[data-id]').attr('data-id');
		if(window['product_' + productid]){
			ga('ec:addProduct', window['product_' + productid]);
			ga('ec:setAction', 'click', {
				'list': window['product_' + productid].list
			});
			ga('send', 'event', 'link', 'click', productid);
		}
	});

	// Promos
	$('.mod_cur_ads a').on('click', function(e){
		ga('ec:addPromo', window[this.id]);
		ga('ec:setAction', 'promo_click');
		ga('send', 'event', 'advertisement', 'click', window[this.id].name);
	});

	// Add to Cart button
	$('input[name=SUBMIT_BUY]').closest('form').on('submit', function(e){
		var productid = $(this).find('input[name=product]').val();
		ga('ec:addProduct', window['product_' + productid]);
		ga('ec:setAction', 'add');
		ga('send', 'event', 'cart', 'add', productid);
		if(typeof fbq === 'function'){
			fbq('track', 'AddToCart', {
				'content_type': 'product',
				'content_ids': productid
			});
		}
	});

	// Remove from Cart button
	$('button.delete').closest('form').on('submit', function(e){
		var productid = $(this).find('input[name=regular]').val();
		ga('ec:addProduct', window['product_' + productid]);
		ga('ec:setAction', 'remove');
		ga('send', 'event', 'cart', 'remove', productid);
	});

	// Use Voucher button
	$('input[name=SUBMIT_ADDTOCARTVOUCHER]').closest('form').on('submit', function(e){
		ga('send', 'event', 'cart', 'voucher', $(this).find('input[name=voucher_code]').val());
	});

	// Checkout option buttons
	$('input[name=SUBMIT_INSTAMLLMENT], input[name=SUBMIT_BILLING_PAYMENT]').closest('form').on('submit', function(e){
		var option = $(this).find('input[type=radio]:checked').attr('id');
		if(typeof checkout_step != 'undefined'){
			ga('ec:setAction', 'checkout_option', {
				'step': checkout_step,
				'option': option
			});
			ga('send', 'event', 'cart', 'checkout_option', option);
		}
	});

	// PAST DUE message
	var pastdue = getUrlParameter('pastdue');
	if(pastdue){
		$("#main").prepend("<p class='pastdue'>You have a PAST DUE payment, please click <a href='/en/manage-card.html'>HERE</a> to update your payment method.</p>");
		$("p.pastdue").css({
			"border": "4px dashed red",
			"font-size": "150%",
			"padding": "15px",
			"text-align": "center",
			"margin-top": "20px"
		});
	}

	// GTM conversion tracking GA4

	$(document).ready(function() {
		var currentUrl = window.location.pathname;
		var queryParams = window.location.search;

		if (currentUrl === '/en/payment-process.html' && queryParams.includes('orderid=')) {
			var transactionLineItems = [];
			var gtmCouponCode = $('.gtm-coupon-code').text();

			// Traverse the DOM to find each order item
			$('.gtm-order-item').each(function() {
				var itemId = $(this).find('.gtm-product-id').text();
				var itemName = $(this).find('.gtm-product-title').text();
				var itemManufacturer = $(this).find('.gtm-product-manufacturer').text();
				var itemCategory = $(this).find('.gtm-product-category').text();
				var itemSecondaryCategory = $(this).find('.gtm-product-secondary-category').text();
				var discount = parseFloat($(this).find('.gtm-product-discount').text()) || 0;
				var price = parseFloat($(this).find('.gtm-product-price').text());
				var quantity = parseInt($(this).find('.gtm-product-quantity').text());

				// Create the product object
				var product = {
					item_id: itemId,
					item_name: itemName,
					item_version: " ",
					affiliation: "Plugin Alliance Store",
					item_brand: itemManufacturer,
					item_category: itemCategory,
					item_category2: itemSecondaryCategory,
					coupon: gtmCouponCode,
					discount: discount,
					price: price,
					quantity: quantity,
				};

				// Push the product object to the transactionLineItems array
				transactionLineItems.push(product);
			});

			// Traverse the DOM to find transaction details
			var productType = $('.gtm-product-type').first().text();
			if (productType !== 'subscription') {
				productType = 'product';
			}
			var orderId = $('.gtm-order-id').text();
			var totalAmount = parseFloat($('.gtm-order-total').text());
			var taxAmount = parseFloat($('.gtm-order-tax-amount').text());
			var gtmPaymentMethod = $('.gtm-payment-method').text();

			// Create the data layer object with the transaction data
			dataLayer.push({
				event: "purchase",
				product_type: productType,
				ecommerce: {
					transaction_id: orderId,
					value: totalAmount,
					tax: taxAmount,
					shipping: 0,
					currency: "USD",
					coupon: gtmCouponCode,
					shipping_tier: "no shipping",
					payment_type: gtmPaymentMethod,
					items: transactionLineItems
				}
			});
		}
	});

	// Utility function to parse price and remove dollar sign
	function parsePrice(priceText) {
		return parseFloat(priceText.replace('$', ''));
	}

	// Utility function to calculate discount
	function calculateDiscount(originalPrice, currentPrice) {
		return Math.max(0, (originalPrice - currentPrice).toFixed(2));
	}

	// Utility function to get subscription details
	function getSubscriptionDetails(billingCycle) {
		var details = {
			productType: "perpetual",
			subscriptionPlan: "",
			subscriptionBillingCycle: ""
		};

		if (billingCycle === "1") {
			details.productType = "subscription";
			details.subscriptionPlan = "monthly";
			details.subscriptionBillingCycle = "1";
		} else if (billingCycle === "12") {
			details.productType = "subscription";
			details.subscriptionPlan = "yearly";
			details.subscriptionBillingCycle = "12";
		}

		return details;
	}

	// Function to push product data to the dataLayer
	function pushProductToDataLayer(product) {
		console.log("Pushing product to dataLayer:", product);

		dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: "view_item",
			product_type: product.product_type,
			subscription_plan: product.subscription_plan,
			subscription_billing_cycle: product.subscription_billing_cycle,
			ecommerce: {
				currency: "USD",
				value: product.price,
				items: [{
					item_id: product.item_id,
					item_name: product.item_name,
					item_version: product.item_version || "",
					affiliation: product.affiliation,
					item_brand: product.item_brand,
					item_category: product.item_category,
					item_category2: product.item_category2,
					coupon: product.coupon || "",
					discount: product.discount || 0,
					price: product.price,
					quantity: product.quantity
				}]
			}
		});
	}

	// Get product details from list page
	function getProductDetailsFromList(productElement) {
		var categories = [];
		var dataCategories = $(productElement).attr('data-categories');

		if (dataCategories) {
			try {
				categories = JSON.parse(dataCategories.replace(/'/g, '"'));
			} catch (e) {
				categories = dataCategories.split(/[\[\]"]+/).filter(Boolean);
			}
		}

		var originalPrice = parsePrice($(productElement).find('.original-price').text());
		var currentPrice = parsePrice($(productElement).find('.current-price').text());

		var subscriptionDetails = getSubscriptionDetails($(productElement).attr('data-billing_cycle'));

		return {
			item_id: $(productElement).attr('data-id'),
			item_name: ($(productElement).find('.product-manufacturer').text() + " " + $(productElement).find('.product-title a').text()).trim(),
			item_version: "",
			affiliation: "Plugin Alliance Store",
			item_brand: $(productElement).find('.product-manufacturer').text().trim(),
			item_category: categories[0] || "",
			item_category2: categories[1] || "",
			coupon: "",
			discount: calculateDiscount(originalPrice, currentPrice),
			price: currentPrice,
			quantity: 1,
			product_type: subscriptionDetails.productType,
			subscription_plan: subscriptionDetails.subscriptionPlan,
			subscription_billing_cycle: subscriptionDetails.subscriptionBillingCycle
		};
	}

	// Function to push Login data to the dataLayer
	function pushLoginToDataLayer(userId){
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'login',
			method: 'email',
			user_id: userId
		});
	}

	// Get product details from details page
	function getProductDetailsFromDetailsPage() {
		var gtmContainer = $('.gtm-product-details-container');
		var pricingContainer = $('.pricing');

		var originalPrice = parsePrice(pricingContainer.find('.original-price').text());
		var currentPrice = parsePrice(pricingContainer.find('.current-price').text());

		var subscriptionDetails = getSubscriptionDetails(gtmContainer.find('.gtm-item-billing-cycle').text().trim());

		return {
			item_id: pricingContainer.find('form input[name="product"]').val(),
			item_name: $('.hero-content h1').text().trim(),
			item_version: "",
			affiliation: "Plugin Alliance Store",
			item_brand: gtmContainer.find('.gtm-item-manufacturer').text().trim(),
			item_category: gtmContainer.find('.gtm-item-category').text().trim(),
			item_category2: gtmContainer.find('.gtm-item-category2').text().trim(),
			coupon: "",
			discount: calculateDiscount(originalPrice, currentPrice),
			price: currentPrice,
			quantity: parseInt(pricingContainer.find('form input[name="quantity"]').val(), 10) || 1,
			product_type: subscriptionDetails.productType,
			subscription_plan: subscriptionDetails.subscriptionPlan,
			subscription_billing_cycle: subscriptionDetails.subscriptionBillingCycle
		};
	}

	// Get product details from plan card
	function getProductDetailsFromPlanCard(planCard) {
		var priceText = $(planCard).find('.price').text().trim();
		var subscriptionDetails = getSubscriptionDetails(priceText.includes("/mo") ? "1" : "12");

		return {
			item_id: subscriptionDetails.subscriptionPlan === "monthly" ? "PA MEGA Monthly" : "PA MEGA Yearly",
			item_name: $(planCard).find('.plan-headline').text().trim(),
			item_version: "",
			affiliation: "Plugin Alliance Store",
			item_brand: "Plugin Alliance",
			item_category: "Subscription Plans",
			item_category2: "",
			coupon: "",
			discount: 0,
			price: parsePrice(priceText),
			quantity: 1,
			product_type: subscriptionDetails.productType,
			subscription_plan: subscriptionDetails.subscriptionPlan,
			subscription_billing_cycle: subscriptionDetails.subscriptionBillingCycle
		};
	}

	// Utility function to push add to cart event to the dataLayer
	function pushAddToCartToDataLayer(product) {
		dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: "add_to_cart",
			product_type: product.product_type,
			ecommerce: {
				currency: "USD",
				value: product.price * product.quantity,
				items: [{
					item_id: product.item_id,
					item_name: product.item_name,
					item_version: product.item_version || "",
					affiliation: product.affiliation,
					item_brand: product.item_brand,
					item_category: product.item_category,
					item_category2: product.item_category2,
					coupon: product.coupon || "",
					discount: product.discount || 0,
					price: product.price,
					quantity: product.quantity
				}]
			}
		});
	}

	// Function to check if the cart is a subscription cart
	function isSubscriptionCart() {
		return $('.order-item .product-type').text().toLowerCase() === 'subscription';
	}

	// Function to check if the cart is a perpetual cart
	function isPerpetualCart() {
		return !isSubscriptionCart() && (
			$('.order-item .product-type').text().toLowerCase() === 'product' ||
			$('.order-item .product-type').text().toLowerCase() === 'bundle'
		);
	}

	// Function to get the total cart value
	function getTotalValue() {
		var totalElement = $('.sum .value').last();
		var totalValueText = totalElement.text().replace('$', '').trim();

		if (totalValueText) {
			return parseFloat(totalValueText) || 0;
		} else {
			var subtotalValueText = $('.sum.subtotal .value').text().replace('$', '').trim();
			return parseFloat(subtotalValueText) || 0;
		}
	}

	// Function to gather data for each cart item
	function getCartItems() {
		var cartItems = [];

		$('.order-item').each(function () {
			var $item = $(this);
			var quantity = parseInt($item.find('.quantity select').val() || $item.find('.quantity').text() || 1, 10);
			var manufacturer = $item.find('.manufacturer').text().trim();
			var title = $item.find('.item-title').text().trim();
			var price = parseFloat($item.find('.price').text().replace('$', '').trim()) || 0;
			var productCategory = $item.find('.product-category').text().trim();
			var productSecondaryCategory = $item.find('.product-secondary-category').text().trim();

			// Retrieve item_id from the hidden input with name="regular"
			var itemId = $item.find('input[name="regular"]').val() || "";

			// Add the item data to cartItems array
			cartItems.push({
				'item_id': itemId,
				'item_name': (manufacturer + " " + title) || "",
				'item_version': "",
				'affiliation': "Plugin Alliance Store",
				'item_brand': manufacturer || "",
				'item_category': productCategory || "",
				'item_category2': productSecondaryCategory || "",
				'coupon': "",
				'discount': 0,
				'price': price,
				'quantity': quantity
			});
		});

		return cartItems;
	}

	// Function to push view_cart event to dataLayer
	function pushViewCartEvent(cartItems, productType) {
		var totalValue = getTotalValue();

		// Clear previous ecommerce data
		dataLayer.push({ ecommerce: null });

		// Push the new view_cart event
		dataLayer.push({
			'event': 'view_cart',
			'product_type': productType,
			'ecommerce': {
				'currency': 'USD',
				'coupon': "",
				'value': totalValue,
				'items': cartItems
			}
		});
	}

	// Helper function to retrieve the subscription plan name
	function getSubscriptionPlan() {
		var subscriptionItem = $('.order-item .product-type').filter(function () {
			return $(this).text().toLowerCase() === "subscription";
		}).closest('.order-item');

		if (subscriptionItem.length > 0) {
			var title = subscriptionItem.find('.item-title').text().toLowerCase();
			if (title.includes("monthly")) {
				return "monthly";
			} else if (title.includes("yearly")) {
				return "yearly";
			}
		}
		return "";
	}

	// Helper function to retrieve the subscription billing cycle
	function getSubscriptionBillingCycle() {
		var subscriptionPlan = getSubscriptionPlan();
		if (subscriptionPlan === "monthly") {
			return 1;
		} else if (subscriptionPlan === "yearly") {
			return 12;
		}
		return 0;
	}

	function pushBeginCheckoutEvent(cartItems, productType, voucherCode) {
		var totalValue = getTotalValue();
		dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: "begin_checkout",
			product_type: productType,
			subscription_plan: productType === "subscription" ? getSubscriptionPlan() : "",
			subscription_billing_cycle: productType === "subscription" ? getSubscriptionBillingCycle() : "",
			ecommerce: {
				currency: "USD",
				coupon: voucherCode,
				value: totalValue,
				items: cartItems
			}
		});
	}

	$(document).ready(function () {
		var pathname = window.location.pathname;

		// Function to handle add to cart event binding
		function bindAddToCartListener(selector, getProductDetailsFn) {
			$(selector).on('click', function () {
				var product = getProductDetailsFn(this);
				if (product) {
					pushAddToCartToDataLayer(product);
				}
			});
		}

		// Product listing page
		if (pathname.indexOf("/products.html") !== -1) {
			bindAddToCartListener('.gtm-add-to-cart', function (element) {
				return getProductDetailsFromList($(element).closest('.enabled'));
			});
		}

		// Product details page
		else if (/\/products\/[a-zA-Z0-9_-]+\.html$/.test(pathname) && !/\/products\/mega-(monthly|yearly)\.html$/.test(pathname)) {
			var product = getProductDetailsFromDetailsPage();
			pushProductToDataLayer(product);

			bindAddToCartListener('.gtm-add-to-cart', function () {
				return getProductDetailsFromDetailsPage();
			});
		}

		// Plan cards (e.g., MEGA plans)
		else if (pathname.includes("/products/mega-yearly.html") || pathname.includes("/products/mega-monthly.html")) {
			$('.plan-chooser .card').each(function () {
				var product = getProductDetailsFromPlanCard(this);
				pushProductToDataLayer(product);
			});

			bindAddToCartListener('.plan-chooser .card .plan-btn a', function (element) {
				return getProductDetailsFromPlanCard($(element).closest('.card'));
			});
		} else if (pathname === "/en/cart.html") {
			var cartData = getCartItems();

			if (isSubscriptionCart() && !sessionStorage.getItem("viewCartTriggered_subscription")) {
				pushViewCartEvent(cartData, "subscription");
				sessionStorage.setItem("viewCartTriggered_subscription", "true");
			} else if (isPerpetualCart() && !sessionStorage.getItem("viewCartTriggered_perpetual")) {
				pushViewCartEvent(cartData, "perpetual");
				sessionStorage.setItem("viewCartTriggered_perpetual", "true");
			}

			// Set up a handler to clear flags when leaving the cart page
			$(window).on("beforeunload", function () {
				sessionStorage.removeItem("viewCartTriggered_subscription");
				sessionStorage.removeItem("viewCartTriggered_perpetual");
			});
		}

		var userInfo = $('#user-info');
		var userId = userInfo.data('user-id');
		var triggerLoginEvent = userInfo.data('trigger-login-event');
		if(userId && triggerLoginEvent) {
			pushLoginToDataLayer(userId);
		}

		$('form[action="/en/cart.html"] input[name="SUBMIT_YOUR_ORDER"]').on('click', function (event) {
			var voucherCode = $('#voucher_code').val().trim() || "";
			var cartData = getCartItems();
			var productType = isSubscriptionCart() ? "subscription" : "perpetual";

			// Push the begin_checkout event
			pushBeginCheckoutEvent(cartData, productType, voucherCode);
		});
	});

	// Google Place API Address Autocomplete

	var autocomplete;

	function initAutocomplete() {
		var currentPath = window.location.pathname;
		var addressInputField = document.querySelector("#billing_address_street");

		if(currentPath === '/en/update-billing.html'){
			addressInputField = document.querySelector("#ctrl_street");
		}

		if(false === addressInputField.hasAttribute('readonly')) {
			autocomplete = new google.maps.places.Autocomplete(addressInputField, {
				fields: ["address_components", "geometry"],
				types: ["address"],
			});

			autocomplete.addListener("place_changed", function () {
				var place = autocomplete.getPlace();
				fillInAddress(place, currentPath);
			});
		}
	}

	function fillInAddress(place, currentPath) {
		var address = [];

		for (var i = 0; i < place.address_components.length; i++) {
			var component = place.address_components[i];
			var componentType = component.types[0];
			if (["postal_town", "sublocality_level_1", "neighbourhood"].includes(componentType)) {
				componentType = "locality";
			}
			address[componentType] = component;
		}

		var addressStreetNumber = address.street_number ? address.street_number.long_name : "";
		var addressStreetName = address.route.short_name;
		var addressStreetNameAndNumber = addressStreetName + " " + addressStreetNumber;
		var addressCityName = address.locality.long_name;
		var addressRegionName = address.administrative_area_level_1.long_name;
		var addressCountryCode = address.country.short_name.toLowerCase();

		if (["us", "ca"].includes(addressCountryCode)) {
			addressStreetNameAndNumber = addressStreetNumber + " " + addressStreetName;
		}

		var addressPostalCode = [];
		if (address.postal_code_prefix) {
			addressPostalCode.push(address.postal_code_prefix.long_name);
		}
		if (address.postal_code) {
			addressPostalCode.push(address.postal_code.long_name);
		}
		if (address.postal_code_suffix) {
			addressPostalCode.push(address.postal_code_suffix.long_name);
		}

		if(currentPath === '/en/update-billing.html'){
			$("#ctrl_city").val(addressCityName);
			$("#ctrl_street").val(addressStreetNameAndNumber);
			$("#ctrl_postal").val(addressPostalCode.join("-"));
			$("#ctrl_state").val(addressRegionName);
			$('#ctrl_country').val(addressCountryCode);

			return;
		}

		$("#billing_address_city").val(addressCityName);
		$("#billing_address_street").val(addressStreetNameAndNumber);
		$("#billing_address_postal").val(addressPostalCode.join("-"));
		$("#billing_address_state").val(addressRegionName);
		$('#billing_address_country').val(addressCountryCode);
		$("#billing_address_country").trigger("change");
	}

	window.initAutocomplete = initAutocomplete;

	// Mega accordion
	$('.mega-accordion-header').click(function () {
		var accordionItem = $(this).parent();
		var accordionContent = accordionItem.find('.mega-accordion-content');
		var toggleIcon = accordionItem.find('.mega-toggle-icon');

		// Close all other sections
		$('.mega-accordion-item').not(accordionItem).removeClass('active');
		$('.mega-accordion-content').not(accordionContent).slideUp();
		$('.mega-toggle-icon').not(toggleIcon).text('+');

		accordionItem.toggleClass('active');

		if (accordionItem.hasClass('active')) {
			accordionContent.slideDown();
			toggleIcon.text('-');
		} else {
			accordionContent.slideUp();
			toggleIcon.text('+');
		}
	});

})(jQuery);